import React, {useState, useEffect} from 'react';
import styled from '@emotion/styled';
import {get} from 'lodash';
import {TextField} from '@mui/material';
import Router from 'next/router';
import {Grid} from '@mui/material';
import {Loader} from 'google-maps';
import axios from 'axios';
import {theme} from '../../../src/themes/default-theme';
import refactorDealerData from '../../../src/data-restructure/pages/dealer'

import getClosestCoordinate from '../../../src/util/getClosestCoodinate';
import getClosestDealersByPostcode from '../../../src/util/getClosestDealersByPostcode';
import getFallbackStateAus from '../../../src/util/getFallbackStateAus';
import postcodeRefactor from '../../../src/util/postcodeRefactor';


// components
import Banner from '../../../src/components/multimedia/Banner';
import BannerSlider from '../../../src/components/multimedia/BannerSlider';
import Text from '../../../src/components/typography';
import Checkbox from '../../../src/components/forms/Checkbox';
import GetLocation from '../../../src/containers/GetLocation';
import getClosestDealer from '../../../src/util/getClosestDealer';
import BodyText from '../../../src/components/content/BodyText';

const Container = styled.div`
  margin: 35px 0;

  ${theme.breakpoints.up('md')} {
    margin: 55px 0;
  }

  ${theme.breakpoints.up('lg')} {
    margin: 90px 0;
  }
`

const BodyTextContainer = styled.div`
  max-width: 780px;
  margin: 35px auto 0;

  ${theme.breakpoints.up('md')} {
    margin: 55px auto 0;
  }

  ${theme.breakpoints.up('lg')} {
    margin: 110px auto 0;
  }
`

const FormBox = styled.div`
  width: 100%;
  max-width: 470px;
  margin: 0 auto;
  padding: 40px 15px;
  background-color: ${theme.palette.lightGrey};
  border-bottom-right-radius: 50px;
  text-align: center;

  ${theme.breakpoints.up('md')} {
    padding: 50px 40px;
    border-bottom-left-radius: 50px;
    border-bottom-right-radius: 0;
  }

  ${theme.breakpoints.up('lg')} {
    max-width: 550px;
    padding: 50px;
    border-bottom-left-radius: 60px;
  }
`

const Form = styled.div`
  margin-top: 25px;
`

const Inputs = styled.div`
  max-width: 250px;
  margin: 15px auto 0;

  ${theme.breakpoints.up('md')} {
    margin: 20px auto 0;
  }

  ${theme.breakpoints.up('lg')} {
    margin: 30px auto 0;
  }
`

const Error = styled.p`
  color: ${theme.palette.error.form};
  text-align: center;
`

const FindADealer = (props) => {

  const {
    dealers,
  } = props

  console.log('find a dealer', props);

  const dealerUri = '/dealer/';
  const countryCode = props.countryProps.countryCode;
  const [filteredDealers, setFilteredDealers] = useState(dealers);
  const [geocoder, setGeocoder] = useState(null);
  const [checked, updateChecked] = useState(false);
  const [postcodeError, updatePostcodeError] = useState(false);
  const [postcodes, setPostcodes] = useState(null);
  const [dealerPmas, setDealerPmas] = useState(null);


  const motorhomeCapvervanDealers = dealers ? dealers.filter(item => {
    if (get(item, 'acf_dealers.motorhomes', '') === "1" || get(item, 'acf_dealers.campervans', '') === "1") {
      return true
    }
  }) : [];

  useEffect(() => {
    const asyncLoad = async () => {
      const loader = new Loader(process.env.GOOGLE_MAPS_API_KEY, {});
      const google = await loader.load();
      setGeocoder(new google.maps.Geocoder())
    }
    asyncLoad()
  }, [])

  useEffect(() => {
    axios.get('/data/postcodes.json', {})
      .then(function (response) {
        setPostcodes(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [])

  useEffect(() => {
    if (countryCode !== 'AU') {
      return;
    }

    const parseCsv = (csvText) => {
      const rows = csvText.split('\n').filter(row => row.trim() !== '');
      const headers = rows[0].split(',').map(header => header.trim());

      return rows.slice(1).map(row => {
        const values = row.split(',').map(value => value.trim());
        return Object.fromEntries(headers.map((header, index) => [header, values[index]]));
      });
    }

    axios.all([
      axios.get('https://www.jayco.com.au/jayco-it/jayco-postcodes-by-territory-motorised-au.csv'),
      axios.get('https://www.jayco.com.au/jayco-it/jayco-postcodes-by-territory-touring-au.csv'),
    ])
    .then(axios.spread(function (motorisedResponse, touringResponse) {
      setDealerPmas({
        motorised: parseCsv(motorisedResponse.data),
        touring: parseCsv(touringResponse.data),
      });
    }))
    .catch(function (error) {
      console.log(error);
    });
  }, [])

  useEffect(() => {
    setFilteredDealers(dealers);
  }, [dealers])

  useEffect(() => {

    const _filteredDealers = checked ? dealers.filter(item => {
      if (get(item, 'acf_dealers.motorhomes', '') === "1" || get(item, 'acf_dealers.campervans', '') === "1") {
        return true
      }
    }) : dealers;

    setFilteredDealers(_filteredDealers);
  }, [checked])

  const getGeoDealerFromPostcode = (postcode) => {

    const country = props.countryProps.countryCode === 'AU' ? 'Australia' : 'New Zealand'
    const fallback = get(filteredDealers[0], 'acf_dealers.country') === 'Australia' ? getFallbackAus(postcode) : getFallbackNz(postcode);

    console.log('getGeoDealerFromPostcode', postcode);

    geocoder.geocode( { 'address': 'postalcode+' + postcode + country}, (results, status) => {
      if (status == 'OK') {
        const latFunc = get(results, '[0].geometry.location.lat', null);
        const lngFunc = get(results, '[0].geometry.location.lng', null);

        if (latFunc && lngFunc) {
          const latLng = {
            latitude: latFunc(),
            longitude: lngFunc()
          }

          const closest = getClosestCoordinate(latLng, filteredDealers.map(item => {
            return {
              ...item,
              longitude: parseFloat(get(item, 'acf_dealers.longitude', '')),
              latitude: parseFloat(get(item, 'acf_dealers.latitude', '')),
            }
          }), filteredDealers);


          console.log('getGeoDealerFromPostcode closest', {results, status, closest});


          if (closest && closest.item && closest.item.uri) {
            console.log('closest', closest);
            Router.push(dealerUri + closest.item.uri).then(() => window.scrollTo(0, 0));
            saveDealer(closest)
          } else {
            console.log('error updatePostcodeError');
            updatePostcodeError(true);
            // fallback && fallback.uri && Router.push(dealerUri + fallback.uri).then(() => window.scrollTo(0, 0));
            // saveDealer(fallback)
            // console.log('fallback1', fallback);
          }
        }
      } else {
        updatePostcodeError(true);
        // fallback && fallback.uri && Router.push(dealerUri + fallback.uri).then(() => window.scrollTo(0, 0));
        // saveDealer(fallback)

      }
    });
  }

  const getFallbackAus = (post_code) => {
    return getFallbackStateAus(post_code, filteredDealers);
  }

  const getFallbackNz = (post_code) => {
    const postcode = parseInt(post_code);
    const closestDealer = getClosestDealersByPostcode(postcode, filteredDealers, 1);
    return closestDealer[0]
  }

  const saveDealer = (dealer) => {
    const data = dealer && dealer.item ? dealer.item : dealer
    const refactoredData = refactorDealerData(data);
    
    // if dealer is sales then save to LS
    if (get(data, 'acf_dealers.sales', '') === '1') {

      data && localStorage.setItem('dealer', JSON.stringify({
        title: data.title,
        uri: data.uri,
        data: refactoredData
      }));

    }
  }

  const normalisePmaPostcode = (pc) => {
    const str = pc.toString();
    return str.length === 3 ? `0${str}` : str;
  }

  // dealerPmas (from the motorised/touring PMA CSVs) is the source of truth for AU postcode -> dealer matching.
  const getPmaDealer = (postcode, pmaKey) => {
    const pmaRow = get(dealerPmas, pmaKey, []).find(row => normalisePmaPostcode(row.PC_pid) === normalisePmaPostcode(postcode));
    return pmaRow && filteredDealers.find(item => get(item, 'acf_dealers.dealerID') === pmaRow.DealerID);
  }

  const getDealerFromPostcode = (_postcode) => {

    let postcode = _postcode;

    const postcodeFromTo = postcodeRefactor

    postcodeFromTo.forEach(item => {
      if (item.from === _postcode.toString()) {
        postcode = item.to
      }
    })

    if (checked) {

      // Superseded by the motorised PMA CSV lookup below now that real PMA data exists.
      // Left here commented out in case the CSV doesn't cover Coffs Harbour correctly in production.
      // const coffsHarbourPostcodes = ['2408', '2409', '2410', '2411', '2475', '2476', '2481', '2482', '2484', '2474', '2480', '2477', '2479', '2372'];
      //
      // const isCoffsHarbourPostcode = coffsHarbourPostcodes.indexOf(postcode.toString()) !== -1;
      //
      // if (isCoffsHarbourPostcode) {
      //     const coffDealer = filteredDealers.find(item => item.title.toLowerCase() === 'watsons coffs harbour');
      //
      //     if (coffDealer) {
      //         coffDealer.uri && Router.push(dealerUri + coffDealer.uri).then(() => window.scrollTo(0, 0));
      //         saveDealer(coffDealer);
      //       return
      //     }
      // }

      if (countryCode === 'AU') {
        const pmaDealer = getPmaDealer(postcode, 'motorised');

        if (pmaDealer) {
          pmaDealer.uri && Router.push(dealerUri + pmaDealer.uri).then(() => window.scrollTo(0, 0));
          saveDealer(pmaDealer);
          return
        }
      }

      getGeoDealerFromPostcode(postcode);
    } else {

      if (countryCode === 'AU') {
        const pmaDealer = getPmaDealer(postcode, 'touring');

        if (pmaDealer) {
          pmaDealer.uri && Router.push(dealerUri + pmaDealer.uri).then(() => window.scrollTo(0, 0));
          saveDealer(pmaDealer);
          return
        }

        getGeoDealerFromPostcode(postcode);
        return
      }

      const closestDealer = getClosestDealer(postcode, filteredDealers, countryCode);

      console.log('closest dealer!', closestDealer, filteredDealers, countryCode);

      if (closestDealer) {
        closestDealer.uri && Router.push(dealerUri + closestDealer.uri).then(() => window.scrollTo(0, 0));
        saveDealer(closestDealer)
      } else {
        getGeoDealerFromPostcode(postcode);
        // const fallback = get(filteredDealers[0], 'acf_dealers.country') === 'Australia' ? getFallbackAus(postcode) : getFallbackNz(postcode);
        // saveDealer(fallback)
        // fallback && fallback.uri && Router.push(dealerUri + fallback.uri);
      }
    }
  }

  const getDealerFromLocation = (location) => {

    const findNearestByCoordinate = () => {
      const closest = getClosestCoordinate(location, filteredDealers.map(item => {
        return {
          ...item,
          longitude: parseFloat(get(item, 'acf_dealers.longitude', '')),
          latitude: parseFloat(get(item, 'acf_dealers.latitude', '')),
        }
      }));
      if (closest && closest.item && closest.item.uri) {
        saveDealer(closest);
        window.location.href = dealerUri + closest.item.uri
        // Router.push(dealerUri + closest.item.uri).then(() => window.scrollTo(0, 0)); // Doesn't work in older versions of chrome and firefox when getting location
      } else {
        const fallback = get(filteredDealers[0], 'acf_dealers.country') === 'Australia' ? getFallbackStateAus(postcode, filteredDealers) : filteredDealers[0];
        saveDealer(fallback);
        window.location.href = dealerUri + closest.item.uri;
      }
    }

    // The PMA CSVs are the source of truth for AU. Find the nearest postcode from the already-loaded
    // postcodes.json (no API cost) and match that against dealerPmas, before falling back to
    // nearest-dealer-by-distance. No Google geocoding call is made in this flow.
    if (countryCode === 'AU' && postcodes && postcodes.length) {
      const nearestPostcode = getClosestCoordinate(location, postcodes);
      const pmaDealer = nearestPostcode.item && getPmaDealer(nearestPostcode.item.postcode, checked ? 'motorised' : 'touring');

      if (pmaDealer) {
        saveDealer(pmaDealer);
        window.location.href = dealerUri + pmaDealer.uri
        return
      }
    }

    findNearestByCoordinate();
  }

  const handleSubmit = (location, type) => {
    
    // AU
    if (type === 'postcode' && countryCode !== 'NZ') {
      const postcode = get(location, 'postcode', null)

      console.log('handleSubmit', {postcode, location, postcodes, countryCode});
     
      if (postcodes.find(item => normalisePmaPostcode(item.postcode) === normalisePmaPostcode(postcode))) {
        updatePostcodeError(false)
        getDealerFromPostcode(postcode)
      } else {
        updatePostcodeError(true)
      }
  
    } else {
      if (type === 'postcode') {
        // NZ
        const postcode = get(location, 'postcode', null);
        getDealerFromPostcode(postcode);
      } else {
        console.log('handleSubmit 2 getDealerFromLocation', {location});
        getDealerFromLocation(location);
      }

    }
  }

  console.log('fad', dealers, dealerPmas);


  return (
    <div>
      {props.heroBanner &&
        <Banner
          {...props.heroBanner}
          largePaddingTop={true}
          priority="high"
        />
      }
      {props.heroBannerSlider &&
        <BannerSlider
          {...props.heroBannerSlider}
        />
      }
      {props.bodyText &&
        <Grid container className={'hasPadding'} spacing={0} direction={'row'} wrap="nowrap" justifyContent={'space-between'} alignItems={'flex-start'}>
          <Grid size={12}>
            <BodyTextContainer>
              <BodyText 
                {...props.bodyText}
                headerType="h4"
                align="center"
              />
            </BodyTextContainer>
          </Grid>
        </Grid>
      }
      <Container>
        <FormBox>
          <Text variant="body1" align="center">Selected Jayco dealerships sell Motorhomes / Campervans. Please tick the checkbox below to find your licensed motorised dealer.</Text>

          <Form>
            {motorhomeCapvervanDealers.length > 1 &&
              <Checkbox
                label="Motorhomes / Campervans"
                value={checked}
                onChange={(event) => updateChecked(event.target.checked)}
                name='motorhomes_campervans'
              />
            }

            <Inputs>
              <GetLocation 
                onSubmit={handleSubmit}
              />
            </Inputs>

            {postcodeError && 
              <Error>Sorry, we can't find a dealer with that postcode.</Error>
            }
            
          </Form>

        </FormBox>
      </Container>
    </div>
  );
}

FindADealer.propTypes = {
}

export default FindADealer